import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { Hero } from '../components/home/Hero';
import { OfferIndex } from '../components/home/OfferIndex';
import { FeaturedVideo } from '../components/home/FeaturedVideo';
import { StoryTeaser } from '../components/home/StoryTeaser';
import { RepertoireTeaser } from '../components/home/RepertoireTeaser';
import { PressList } from '../components/home/PressList';
import { CtaBand } from '../components/ui/CtaBand';
export function Home() {
  usePageTitle();
  return <>
      <Hero data-id="element-332" data-mp="24htpif06emfz" />
      <OfferIndex data-id="element-333" data-mp="24haihtc2digq" />
      <FeaturedVideo data-id="element-334" data-mp="24ivc9gqk0xdj" />
      <StoryTeaser data-id="element-335" data-mp="29gdaod6y3u7a" />
      <RepertoireTeaser data-id="element-336" data-mp="29fvfljw0rm0y" />
      <PressList data-id="element-337" data-mp="29ek5l2bzdi1e" />
      <CtaBand title="Zullen we iets muzikaals plannen?" text="Vertel me over uw gelegenheid of je muzikale wens. Ik reageer meestal binnen één werkdag." to="/contact" label="Neem contact op" data-id="element-338" data-mp="29i7z41hfe4g4" />
    </>;
}